<div class="reports-simple-campaigns-page records-page datatable-page-shell">
	<div class="records-page__hero reports-simple-campaigns-hero">
		<div class="records-page__hero-primary">
			<div class="records-page__hero-headline">
				<span class="records-page__hero-eyebrow">{{ 'REPORTS' | translate }}</span>
				<h3 class="records-page__hero-title">{{ 'CAMPAIGN_REPORTS' | translate }}</h3>
			</div>
		</div>
	</div>

	<div class="details-tab-surface reports-simple-campaigns-surface datatable-page-surface">
		<app-campaign-datatable class="records-page__table" [iCanRead]="doWhat.canRead" [iCanWrite]="doWhat.canWrite" [iCanDelete]="doWhat.canDelete" [iColumns]="columns" [iData$]="campaignsData" [iRowLinkHandler]="getRowLink" [iShowViewAction]="false" [iShowExternalAction]="false" [iShowActions]="false" [iShowExport]="false" [iShowSelect]="false" [iShowEditAction]="false" [iShowDeleteAction]="false" (oLoadDataFromServer)="onLoadingData($event)" [iIsServerLoading]="true" [iTotalCount]="dataTotalCount">
		</app-campaign-datatable>
	</div>
</div>